<script>
    import {elementBodyClickListener} from '../../../lib/body-click-listener-helper'
    import clipboard from 'clipboard-polyfill'
    import {nextTick} from "vue";
    import {Listeners} from "../../../constants/listeners";
    export default {
        data() {
            return {
                viewMenu: false,
                align: 'left',
                ctxTop: 0,
                ctxLeft: 0,
                bodyClickListener: elementBodyClickListener(this, 'contextMenu', 'viewMenu')
            }
        },
        props: {
            cell:{
                type: Object,
                required: false
            }
        },
        mounted: function () {

        },
        methods: {
            copyToClipBoard(){
                clipboard.writeText(this.cell.value);
            },
            setFilter(condition){
                this.$emitter.emit(Listeners.KS_FILTER_CONTEXT_SET, {
                    type: this.cell.fieldConfig.type,
                    name: this.cell.fieldConfig.name,
                    value: this.cell.value,
                    condition: condition
                });
            },
            closeMenu(){
                this.viewMenu = false;
            },

            openMenu(e){
                this.viewMenu = true;
                this.setPositionFromEvent(e);
                this.bodyClickListener.start();
            },

            openDomainReport(){

                let a = document.createElement("a");
                a.target = "_blank";
                a.href = "/" + window.locale + "/report?domain=" + this.cell.value;
                a.click();

            },

            setPositionFromEvent(e) {
                e = e || window.event;

                let self = this;
                nextTick(() => {
                    self.ctxLeft = e.clientX;
                    self.ctxTop = e.clientY;
                });
            },

            makeMasterKey(){
                this.$emitter.emit(Listeners.KS_TABLE_MAKE_MASTER_KEY, this.cell.row);

            }
        },
        computed: {
            style () {
                return {
                    'display': this.viewMenu ? 'block' : 'none',
                    'top': (this.ctxTop || 0) + 'px',
                    'left': (this.ctxLeft || 0) + 'px'
                }
            },
        },
        watch: {
            cell: function (val) {
                if(val){
                    this.openMenu(this.cell.event)
                }
            },
            viewMenu(newVal, oldVal) {
                if (oldVal === true && newVal === false) {
                    this.bodyClickListener.stop();
                }
            }
        }


    }
</script>
<template>
    <ul class="ks-context-menu" tabindex="-1" ref="contextMenu" v-if="viewMenu" :style="style">
        <li @click.prevent="openDomainReport()" v-if="cell.fieldConfig.callback === 'domain'">{{$t('lang.main.table.components.context_filter.open_report')}}</li>
        <li @click.prevent="makeMasterKey()" v-if="cell.row.hasOwnProperty('master_key') && cell.row.master_key === 0">{{$t('lang.main.table.components.context_filter.make_key')}}</li>
        <li @click.prevent="setFilter('=')">{{$t('lang.main.table.components.context_filter.find_matches')}}</li>
        <li @click.prevent="setFilter('!=')">{{$t('lang.main.table.components.context_filter.exclude_search')}}</li>
        <li @click.prevent="setFilter('>=')" v-if="cell.fieldConfig.type === 'number'">{{$t('lang.main.table.components.context_filter.more_equal')}}</li>
        <li @click.prevent="setFilter('<=')" v-if="cell.fieldConfig.type === 'number'">{{$t('lang.main.table.components.context_filter.less_equal')}}</li>
        <li @click.prevent="copyToClipBoard">{{$t('lang.main.btn.copy')}}</li>
    </ul>
</template>
<style scoped>

    .ks-context-menu{
        background: #f9fafb;
        border: 1px solid #BDBDBD;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);
        display: block;
        list-style: none;
        margin: 0;
        padding: 0;
        position: fixed;
        width: 200px;
        z-index: 999999;
    }

    .ks-context-menu li {
        border-bottom: 1px solid #E0E0E0;
        margin: 0;
        padding: 5px 10px;
        cursor: pointer;
        font-size: 13px;
    }

    .ks-context-menu li:last-child {
        border-bottom: none;
    }

    .ks-context-menu li:hover {
        background: #1E88E5;
        color: #FAFAFA;
    }

</style>
